import { maxBy } from 'lodash/fp';
import { createSelector } from 'reselect';
import { indicatorSelector } from 'selectors/basic';

export const timeframeAll = createSelector(
  indicatorSelector,
  ({ timeframes }) => timeframes
);

export const timeframeLatest = createSelector(
  timeframeAll,
  (timeframes) => maxBy('value', timeframes),
);

export default {
  timeframeAll,
  timeframeLatest,
};



// WEBPACK FOOTER //
// ./app/selectors/indicator/timeframe.js